import { Amplify } from 'aws-amplify';

/**
 * AWS Amplify Configuration
 * Configures Cognito authentication for the frontend
 */
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      loginWith: {
        email: true,
        oauth: {
          domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [import.meta.env.VITE_OAUTH_REDIRECT_URL || window.location.origin],
          redirectSignOut: [import.meta.env.VITE_OAUTH_REDIRECT_URL || window.location.origin],
          responseType: 'code',
        },
      },
    },
  },
});

// Export environment variables for easy access
export const awsConfig = {
  region: import.meta.env.VITE_AWS_REGION,
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  apiUrl: import.meta.env.VITE_API_URL,
};
